'use client';

import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { AppIcon } from '@/components/pwa/app-icon';
import { Button } from '@/components/ui/button';
import { detectDevice, snooze, snoozed, startInstall, usePwa } from '@/lib/pwa';
import { cn } from '@/lib/utils';

const SNOOZE_KEY = 'invexa.installBanner';

/**
 * "Instale o app" strip for phones browsing in a tab (never inside the installed app).
 * Tapping it opens the native prompt (Android) or the step-by-step guide (iPhone).
 */
export function InstallBanner({ className }: { className?: string }) {
  const standalone = usePwa((s) => s.standalone);
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(detectDevice().platform !== 'desktop' && !snoozed(SNOOZE_KEY));
  }, []);
  if (!show || standalone) return null;
  return (
    <div className={cn('flex items-center gap-3 border-b border-lime/20 bg-gradient-to-r from-lime/12 via-panel to-panel px-4 py-2.5 md:hidden', className)}>
      <AppIcon className="size-9" />
      <button type="button" onClick={() => void startInstall()} className="min-w-0 flex-1 text-left">
        <span className="block truncate text-[13px] font-semibold text-fg">Instale o app Invexa</span>
        <span className="block truncate text-[11.5px] text-fg-3">Abre em um toque e avisa quando o robô bater a meta</span>
      </button>
      <Button variant="primary" size="sm" className="h-8 px-3" onClick={() => void startInstall()}>
        Instalar
      </Button>
      <button
        type="button"
        aria-label="Agora não"
        className="-mr-1 rounded-md p-1 text-fg-3 hover:text-fg"
        onClick={() => {
          snooze(SNOOZE_KEY, 3);
          setShow(false);
        }}
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
